import { render, staticRenderFns } from "./WhatsAppIcon.vue?vue&type=template&id=cef8b024&scoped=true&"
import script from "./WhatsAppIcon.vue?vue&type=script&lang=js&"
export * from "./WhatsAppIcon.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppIcon.vue?vue&type=style&index=0&id=cef8b024&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef8b024",
  null
  
)

export default component.exports